import React from 'react'

import { Box, Button, Icon, Title } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface EditActionProps {
  onClick: () => void
  icon: React.ComponentProps<typeof Icon.Medium>['icon']
}
interface Props {
  title: string
  description: string
  illustration: React.ComponentProps<typeof Icon.Large>['icon']
  children: React.ReactNode
  submitAction?: () => void
  editAction?: EditActionProps
  disabled?: boolean
}

const FormSection: React.FC<Props> = ({
  title,
  description,
  illustration,
  children,
  submitAction,
  disabled,
  editAction,
}) => {
  return (
    <Box
      boxShadow="s200"
      borderRadius={{ all: 'abs006' }}
      background="grey000White"
      padding="s40"
      gap="s24"
    >
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Title variant="600" illustration={illustration} title={title} description={description} />
        <Box height="full" flexDirection="column" justifyContent="flexEnd" paddingBottom="s8">
          <Box flexDirection="row" gap="s8">
            {!!submitAction && (
              <Button onClick={() => submitAction()} type="primary" disabled={disabled}>
                {i18n.t('common.submit')}
              </Button>
            )}
            {editAction && (
              <Button
                onClick={editAction.onClick}
                type="secondary"
                iconName={editAction.icon}
              ></Button>
            )}
          </Box>
        </Box>
      </Box>
      <Box>{children}</Box>
    </Box>
  )
}

export default FormSection
